import cx from 'classnames'
import React from 'react'
import { IProps } from './Interface'
import { FormLabel } from '@material-ui/core'
import { LabelPosition } from 'types'
import { Box, Select as MuiSelect } from '@material-ui/core'
import useStyles from './Styles'

const Select: React.FC<IProps> = ({ labelPosition, minWidthLabel, label, alwaysEnabled, classNames, ...props }) => {
  const classes = useStyles({ labelPosition, minWidthLabel, alwaysEnabled })

  return (
    <Box display="flex" justifyContent="flex-start" className={classes.root}>
      {label && <FormLabel className={cx(classes.label, classNames?.label)}>{label}</FormLabel>}
      <MuiSelect
        className={cx(classes.select, classNames?.select)}
        classes={{
          root: classes.selectRoot
        }}
        {...props}
      />
    </Box>
  )
}

Select.defaultProps = {
  label: '',
  minWidthLabel: 100,
  labelPosition: LabelPosition.Left,
  alwaysEnabled: true,
  classNames: {
    label: '',
    select: ''
  }
}

export default Select
